import React, { useState } from "react";
import styled from "styled-components";
import Icon from "../../SVGs/ShowMore.svg";

function Information(props) {
  const [isBodyVisible, setBodyVisible] = useState(false);

  const toggleBodyVisibility = () => {
    setBodyVisible(!isBodyVisible);
  };

  return (
    <Container>
      <Header isVisible={isBodyVisible}>
        {props.header}
        <IconButton isRotated={isBodyVisible} onClick={toggleBodyVisibility}>
          <img src={Icon} alt="Show More" />
        </IconButton>
      </Header>
      <Body bodyColor={props.bodyColor} isVisible={isBodyVisible}>
        {props.body}
      </Body>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${(props) =>
    props.isVisible ? "20px 20px 2px 2px;" : "20px 20px 20px 20px;"};
  background: var(--darkBlue);
  width: 100%;
  padding: 5px 20px;

  transition: border-radius 0.5s ease;

  color: #fff;
  font-family: "Museo Sans Cyrl";
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 80% */
`;

const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  img {
    width: 24px;
    height: 24px;
    transition: transform 0.3s ease;
    ${(props) =>
      props.isRotated
        ? "transform: rotate(0deg);"
        : "transform: rotate(180deg);"}
  }
`;

const Body = styled.div`
  width: 100%;
  padding: 10px 20px;
  border-radius: 0px 0px 20px 20px;
  background: ${(props) => (props.bodyColor ? props.bodyColor : "#e6f6fd")};
  color: #304961;
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px; /* 150% */
  max-height: ${(props) => (props.isVisible ? "1000px" : "0")};
  overflow: hidden;
  transition: max-height 0.5s ease, padding 0.3s ease;
  padding: ${(props) => (props.isVisible ? "10px 40px" : "0 40px")};
`;

export default Information;
